import { lazy } from 'react';
export var VotingSinglePageAsync = lazy(function () { return import('./VotingSinglePage'); });
